import React, { useState, useEffect } from 'react';
import DashLayout from '../componets/layout/DashLayout';
import Preloader from '../componets/layout/preloader';
import './categories.css';
import './users.css';
import { supabase } from '../supabaseClient';

const Categories = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editItem, setEditItem] = useState(null);

    const initialForm = { name_en: "", name_ar: "", subtitle_en: "", subtitle_ar: "", icon_name: "", event_count: 0 };
    const [form, setForm] = useState(initialForm);
    const [editForm, setEditForm] = useState(initialForm);

    useEffect(() => {
        const getData = async () => {
            const { data } = await supabase.from('categories').select('*');
            setData(data);
            setLoading(false);
        };
        getData();
    }, []);

    const openEditModal = (item) => {
        setEditItem(item);
        setEditForm(item);
        setEditModalOpen(true);
    };

    const updateCategory = async (e) => {
        e.preventDefault();
        const updatePayload = {
            name_en: editForm.name_en,
            name_ar: editForm.name_ar,
            subtitle_en: editForm.subtitle_en,
            subtitle_ar: editForm.subtitle_ar,
            icon_name: editForm.icon_name,
            event_count: editForm.event_count
        };
        const { error } = await supabase.from('categories').update(updatePayload).eq('id', editItem.id);
        if (!error) {
            setData(prev => prev.map(item => item.id === editItem.id ? { ...item, ...updatePayload } : item));
            setEditModalOpen(false);
        }
    };

    const createCategory = async (e) => {
        e.preventDefault();
        const { data: inserted, error } = await supabase.from('categories').insert([form]).select();
        if (!error && inserted) {
            setData(prev => [...prev, inserted[0]]);
            setModalOpen(false);
            setForm(initialForm);
        }
    };

    const handleDelete = async (id) => {
        await supabase.from('categories').delete().eq('id', id);
        setData(prev => prev.filter(item => item.id !== id));
    };

    return (
        <>
                        <Preloader />

            {modalOpen && (
                <div className="us-overlay">
                    <div className="us-modal">
                        <div className="us-modal-header">
                            <h2 className="us-modal-title">Add New Category</h2>
                            <svg className="us-modal-close" onClick={() => setModalOpen(false)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="us-modal-body">
                            <form className="us-form" onSubmit={createCategory}>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Title (EN)</label>
                                        <input required type="text" className="us-form-input" value={form.name_en} onChange={(e) => setForm({...form, name_en: e.target.value})} />
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Title (AR)</label>
                                        <input required type="text" className="us-form-input" dir="rtl" value={form.name_ar} onChange={(e) => setForm({...form, name_ar: e.target.value})} />
                                    </div>
                                </div>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Subtitle (EN)</label>
                                        <input required type="text" className="us-form-input" value={form.subtitle_en} onChange={(e) => setForm({...form, subtitle_en: e.target.value})} />
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Subtitle (AR)</label>
                                        <input required type="text" className="us-form-input" dir="rtl" value={form.subtitle_ar} onChange={(e) => setForm({...form, subtitle_ar: e.target.value})} />
                                    </div>
                                </div>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Icon URL</label>
                                        <input required type="text" className="us-form-input" placeholder="https://example.com/icon.png" value={form.icon_name} onChange={(e) => setForm({...form, icon_name: e.target.value})} />
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Event Count</label>
                                        <input required type="number" className="us-form-input" value={form.event_count} onChange={(e) => setForm({...form, event_count: e.target.value})} />
                                    </div>
                                </div>
                                <div className="us-form-footer">
                                    <button type="button" className="us-cancel-btn" onClick={() => setModalOpen(false)}>Cancel</button>
                                    <button type="submit" className="us-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        Save Category
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {editModalOpen && (
                <div className="us-overlay">
                    <div className="us-modal">
                        <div className="us-modal-header">
                            <h2 className="us-modal-title">Edit Category</h2>
                            <svg className="us-modal-close" onClick={() => setEditModalOpen(false)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="us-modal-body">
                            <form className="us-form" onSubmit={updateCategory}>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Title (EN)</label>
                                        <input required type="text" className="us-form-input" value={editForm.name_en} onChange={(e) => setEditForm({...editForm, name_en: e.target.value})} />
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Title (AR)</label>
                                        <input required type="text" className="us-form-input" dir="rtl" value={editForm.name_ar} onChange={(e) => setEditForm({...editForm, name_ar: e.target.value})} />
                                    </div>
                                </div>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Subtitle (EN)</label>
                                        <input required type="text" className="us-form-input" value={editForm.subtitle_en} onChange={(e) => setEditForm({...editForm, subtitle_en: e.target.value})} />
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Subtitle (AR)</label>
                                        <input required type="text" className="us-form-input" dir="rtl" value={editForm.subtitle_ar} onChange={(e) => setEditForm({...editForm, subtitle_ar: e.target.value})} />
                                    </div>
                                </div>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Icon URL</label>
                                        <input required type="text" className="us-form-input" value={editForm.icon_name} onChange={(e) => setEditForm({...editForm, icon_name: e.target.value})} />
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Event Count</label>
                                        <input required type="number" className="us-form-input" value={editForm.event_count} onChange={(e) => setEditForm({...editForm, event_count: e.target.value})} />
                                    </div>
                                </div>
                                <div className="us-form-footer">
                                    <button type="button" className="us-cancel-btn" onClick={() => setEditModalOpen(false)}>Cancel</button>
                                    <button type="submit" className="us-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        Update Category
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <DashLayout title="Categories Management" active="categories">
                <div className="cat-top">
                    <div className="cat-top-left">
                        <h1 className="cat-title">Manage Event Categories</h1>
                        <p className="cat-sub">Manage event categories displayed on your website</p>
                    </div>
                    <button className="cat-add-btn" onClick={() => setModalOpen(true)}>
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                        Add Category
                    </button>
                </div>

                <div className="cat-table-wrap">
                    {loading ? (
                        <p className='loading'>Loading...</p>
                    ) : (
                        <table className="cat-table">
                            <thead>
                                <tr>
                                    <th>Img</th>
                                    <th>Title (EN)</th>
                                    <th>Title (AR)</th>
                                    <th>Subtitle (EN)</th>
                                    <th>Subtitle (AR)</th>
                                    <th>Count</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item) => (
                                    <tr key={item.id}>
                                        <td><img src={item.icon_name} alt="icon" className="cat-icon-img" /></td>
                                        <td><input type="text" className="cat-input" readOnly value={item.name_en} /></td>
                                        <td><input type="text" className="cat-input" readOnly value={item.name_ar} dir="rtl" /></td>
                                        <td><input type="text" className="cat-input" readOnly value={item.subtitle_en} /></td>
                                        <td><input type="text" className="cat-input" readOnly value={item.subtitle_ar} dir="rtl" /></td>
                                        <td><input type="text" className="cat-input cat-input--count" readOnly value={item.event_count} /></td>
                                        <td>
                                            <div className="us-actions">
                                                <button className="us-action-btn us-action-btn--edit" onClick={() => openEditModal(item)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14.5 2.5a2.121 2.121 0 013 3L6 17H3v-3L14.5 2.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                                                    </svg>
                                                </button>
                                                <button className="us-action-btn us-action-btn--delete" onClick={() => handleDelete(item.id)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M3 5h14M8 5V3h4v2M6 5l1 11h6l1-11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

           
            </DashLayout>
        </>
    );
};

export default Categories;